import { gql } from '@/__generated__';
import Box from '@/components/ui/Box';
import Flex from '@/components/ui/Flex';
import Txt from '@/components/ui/Txt';
import { createBlock } from '@/lib/parsers/blocks';
import { toNumber } from '@liquorice/utils';
import { BlockContainer } from '../../BlockContainer';
import StarSvg from './StarSvg';

export const QUOTE_BLOCK_FRAGMENT = gql(`
  fragment quoteBlock on quoteItem_Entry {
    heading 
    label
    starAmount
  }
`);

export const QuoteBlock = createBlock(QUOTE_BLOCK_FRAGMENT, ({ data, meta }) => {
  const { heading, label } = data;

  const starAmount = toNumber(data.starAmount);

  if (!heading) return null;

  return (
    <BlockContainer
      {...{
        meta,
        marginY: true,
        customAnchor: heading,
      }}>
      <Flex colorSet="white" paper justifyContent="center" alignItems="center" cx={{ pX: 'md' }}>
        {starAmount > 0 && (
          <Flex direction="row" spacing="6xs" cx={{ mB: 'sm' }}>
            {Array.from({ length: starAmount }, (_, i) => (
              <Box
                key={i}
                cx={{ color: 'black' }}
                style={{ height: '1.375rem', width: '1.4375rem' }}>
                <StarSvg />
              </Box>
            ))}
          </Flex>
        )}
        <Txt variant="h3" cx={{ textAlign: 'center' }} weight="regular" color="black">
          &ldquo;{heading}&rdquo;
        </Txt>
        {label && (
          <Txt color="black" cx={{ textAlign: 'center', width: 'full' }}>
            {label}
          </Txt>
        )}
      </Flex>
    </BlockContainer>
  );
});

export default QuoteBlock;
